import React from "react";
import {
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
  Stack,
  Grid,
  Box,
} from "@mui/material";

const KitchenPricing = ({ kitchen }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const formatValue = (value) => (value || value === 0 ? `$${value}` : "N/A");
  const formatMinBooking = (value) =>
    value || value === 0 ? `${value} hour(s)` : "N/A";

  const pricingItems = [
    {
      label: "Minimum Booking",
      value: formatMinBooking(kitchen.MinBooking),
      key: "minBooking",
    },
    {
      label: "Security Deposit",
      value: formatValue(kitchen.SecurityDeposit),
      key: "deposit",
    },
    {
      label: "Cleaning Fee",
      value: formatValue(kitchen.CleaningFee),
      key: "cleaning",
    },
  ];

  return (
    <Box sx={{ p: 0, m: 0 }}>
      {" "}
      {/* No parent padding or margin */}
      <Typography
        variant={isMobile ? "subtitle1" : "h6"}
        color="text.primary"
        fontWeight={600}
        sx={{
          mt: 0.5, 
          mb: 0,
          bgcolor: "background.paper",
          "&": {
            marginTop: "4px !important",
            marginBottom: "0 !important",
          },
        }}
      >
        Price Details
      </Typography>
      <Divider
        sx={{
          bgcolor: "divider",
          opacity: 0.5,
          "&": {
            marginTop: "8px !important",
            marginBottom: "8px !important",
          },
        }}
      />
      {isMobile ? (
        <Stack direction="column" spacing={0}>
          {pricingItems.map((item) => (
            <Stack key={item.key} direction="column" sx={{ mb: 0.5 }}>
              <Typography
                variant="body1"
                color="text.primary"
                fontWeight={500}
                sx={{
                  mt: 0,
                  mb: 0.5,
                  fontSize: { xs: "1rem", md: "1.125rem" },
                  "&": {
                    marginTop: "6px !important",
                  },
                }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                fontWeight={400}
                sx={{
                  fontSize: { xs: "0.875rem", md: "1rem" },
                  lineHeight: 1.8,
                }}
              >
                {item.value}
              </Typography>
            </Stack>
          ))}
          <Box sx={{ mb: 0 }} />{" "}
          {/* Small bottom margin to align with reference lines */}
        </Stack>
      ) : (
        <Grid container spacing={0}>
          <Grid item xs={6}>
            {pricingItems.map((item) => (
              <Typography
                key={item.key}
                variant="body1"
                color="text.primary"
                fontWeight={500}
                sx={{ mb: 0.5, fontSize: "1.125rem" }}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>
          <Grid item xs={6}>
            {pricingItems.map((item) => (
              <Typography
                key={item.key}
                variant="body1"
                color="text.secondary"
                fontWeight={400}
                sx={{
                  mb: 0.5,
                  fontSize: "1rem",
                  textAlign: "right",
                  lineHeight: 1.8,
                }}
              >
                {item.value}
              </Typography>
            ))}
          </Grid>
          <Box sx={{ mb: 0.5 }} />{" "}
          {/* Small bottom margin to align with reference lines */}
        </Grid>
      )}
    </Box>
  );
};

export default KitchenPricing;
